module.exports = __webpack_public_path__ + "static/media/shoprox.780532f4.webp";